import { Action } from '@ngrx/store';

export enum AuthenticationActionTypes {
    Login = '[Authentication] Login',
    Logout = '[Authentication] Logout'
}

export class Login implements Action {
    readonly type: AuthenticationActionTypes.Login = AuthenticationActionTypes.Login;
}

export class Logout implements Action {
    readonly type: AuthenticationActionTypes.Logout = AuthenticationActionTypes.Logout;
}

export type AuthenticationActions = Login | Logout;
